import { useEffect } from "react";

import { useToasters } from "@mobsuccess-devops/react-ui/Toaster/use-toasters";

import { registerMutationErrorToaster } from "../../features/mutation-error-toast";

// Hands the toaster of the surrounding <Toaster> over to the MutationCache
// error hook (see features/mutation-error-toast.ts), which runs outside React.
export function MutationErrorToaster(): null {
  const { toast } = useToasters();
  useEffect(() => registerMutationErrorToaster(toast), [toast]);
  return null;
}
